import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const cancelled = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancel" : "checking"); // checking | success | timeout | cancel
  const attempts = useRef(0);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let alive = true;
    const poll = async () => {
      if (!alive) return;
      if (attempts.current >= 8) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("timeout"); return; }
      } catch { /* ignore */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { alive = false; };
  }, [sessionId, cancelled]);

  const box = (icon, title, sub, btnLabel, to) => (
    <div className="min-h-screen bg-[#060c18] flex items-center justify-center px-6">
      <div className="w-full max-w-sm text-center border border-[#14233d] bg-gradient-to-b from-[#0B1526] to-[#0A1120] rounded-3xl p-8 fade-up">
        {icon}
        <h1 className="font-heading text-2xl font-bold text-white mt-4">{title}</h1>
        <p className="text-sm text-[#8fb4e6] mt-2 leading-relaxed">{sub}</p>
        {btnLabel && (
          <button data-testid="payment-return-btn" onClick={() => navigate(to)}
            className="mt-6 h-11 px-8 rounded-full font-heading font-semibold text-black w-full"
            style={{ backgroundColor: "var(--sfx-accent)" }}>{btnLabel}</button>
        )}
      </div>
    </div>
  );

  if (state === "checking")
    return box(<Loader2 className="h-10 w-10 animate-spin mx-auto text-[#1C8CFF]" />,
      "Ap konfime peman ou...", "Tann yon ti moman pandan n ap verifye peman an ak Stripe.", null, null);
  if (state === "success")
    return box(<CheckCircle2 className="h-12 w-12 mx-auto text-[#22e07b]" />,
      "Peman Reyisi!", "Abònman ou aktive otomatikman. Ou ka kòmanse itilize Smart Scalper Fx kounye a.",
      "Ale nan Dashboard", "/app");
  if (state === "cancel")
    return box(<XCircle className="h-12 w-12 mx-auto text-[#f5a623]" />,
      "Peman anile", "Ou anile peman an. Ou ka eseye ankò nenpòt lè.", "Retounen nan Plan yo", "/app/billing");
  return box(<XCircle className="h-12 w-12 mx-auto text-[#ff5b5b]" />,
    "Nou poko konfime", "Si ou te peye, aksè ou ap aktive nan kèk segond. Verifye Dashboard ou.",
    "Ale nan Dashboard", "/app");
}
